<div class="modal confirmation-reason-modal" tabindex="-1" role="dialog" id="appModal">
    <div class="modal-dialog" role="document">
        <div class="modal-content">

            <div class="modal-header">

                <p class="text-center font-weight-bold">{{confirmationText}}</p>


                <p class="text-center font-weight-bold mt-1">{{code}}</p>


            </div>
            <div class="modal-body">

                <p>{{'ConfirmationReason.Reason' | translate}}</p>
                <textarea rows="3" class="form-control" hznTestId="confirmation-reason-text" [(ngModel)]="reason" maxlength="2000"></textarea>
            </div>
            <div class="modal-footer justify-content-center">
                <button type="button" class="btn btn-cancel" data-dismiss="modal" (click)="onNo()">{{'General.Cancel' | translate}}</button>

                <button type="button" class="btn btn-success" data-dismiss="modal" hznTestId="confirmation-reason-confirm" (click)="onYes()" [disabled]="!reason">{{confirmButtonText}}</button>
            </div>
        </div>
    </div>
</div>